import { render, staticRenderFns } from "./StockCreate.vue?vue&type=template&id=7822fc88&scoped=true&"
import script from "./StockCreate.vue?vue&type=script&lang=js&"
export * from "./StockCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7822fc88",
  null
  
)

export default component.exports